import { render, staticRenderFns } from "./TablePurchaseOrderPreview.vue?vue&type=template&id=1cfe1871&scoped=true&"
import script from "./TablePurchaseOrderPreview.vue?vue&type=script&lang=js&"
export * from "./TablePurchaseOrderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe1871",
  null
  
)

export default component.exports